module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fullscreen ? _vm.$vuetify.breakpoint.height + 'px' : 'auto',
      "tabindex": "-1"
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('enter')
      }]
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (!_vm.listable) ? _c('v-card', {
    staticClass: "scroll-y",
    attrs: {
      "flat": "",
      "max-height": _vm.calcDialogScroll(_vm.deltas[0] + _vm.delta, (_vm.deltas[1] || _vm.deltas[0]) + _vm.delta)
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.listable) ? _c('v-card-scroll', {
    attrs: {
      "flat": "",
      "height": _vm.calcDialogScroll(_vm.deltas[0] + _vm.delta, (_vm.deltas[1] || _vm.deltas[0]) + _vm.delta)
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.actions) ? _c('v-card-actions', [_vm._t("actions"), _vm._v(" "), _c('span', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": function($event) {
        return _vm.firstFocus()
      }
    }
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e8bc218","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BtnForm.vue
// module id = 801
// module chunks = 1